export default __webpack_public_path__ + "static/media/35.ab893108.jpeg";